var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-card-title',[_c('h2',[_vm._v("Documents")])]),_c('documents',{attrs:{"driver-data":_vm.driverData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }